/* AVISTAR collection cards: variant-price update + AJAX add-to-cart that opens the cart drawer. */
(function () {
  // Update the displayed price when a variant is chosen.
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-av-variant-select]');
    if (!sel) return;
    var card = sel.closest('[data-av-card]');
    if (!card) return;
    var opt = sel.options[sel.selectedIndex];
    var priceEl = card.querySelector('[data-av-price]');
    var price = opt && opt.getAttribute('data-price');
    if (price && priceEl) priceEl.textContent = price;
  });

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (b) { b.textContent = count; });
  }

  // Add to cart from a card form -> open the slide-out cart drawer.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-av-cart-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.av-pcard__atc');
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var original = btn ? btn.textContent.trim() : 'Add to cart';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    var cartDrawer = document.querySelector('cart-drawer');
    var sections = (cartDrawer && cartDrawer.getSectionsToRender)
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: 1, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) {
        if (cartDrawer && cartDrawer.renderContents) {
          cartDrawer.renderContents(res); // swaps drawer contents + opens it
        } else {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCartCount(c.item_count); });
        }
        if (btn) { btn.textContent = original; btn.disabled = false; }
      })
      .catch(function () { form.submit(); });
  });
})();
